import { useMutation } from 'react-query';
import {
  createTelegramIdAsync,
  deleteTelegramIdAsync,
  getTelegramIdByIdAsync,
  updateTelegramIdAsync,
} from '../../index';

export const useCreateTelegramId = () => useMutation(createTelegramIdAsync);

export const useUpdateTelegramId = () => useMutation(updateTelegramIdAsync);

export const useDeleteTelegramId = () => useMutation(deleteTelegramIdAsync);

export const useGetTelegramIdById = () => useMutation(getTelegramIdByIdAsync);
